import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from './style';
import VenueComponent from 'storybookComponents/Venue';
import './style.css';
import JoinUsForm from "./joinUs"


export default withStyles(styles)(({ classes, values, setFieldValue, setValues, status, onTryToEdit, poupStateChange, ...props }) => {
  return (
    <div>
      <JoinUsForm popoverId="JoinUsPopover" classes={classes} values={values} setFieldValue={setFieldValue} hylyFormFields={props.hylyFormFields} />
      <div className={classes.venueContainer}>
        <VenueComponent
          {...values}
          onChange={(venue) => {
            console.log("venue: ", venue)
            setValues({
              ...values,
              ...venue
            })
          }}
          disabled={status === "published" || status === "invited" || status === "invite_scheduled"}
          onTryToEdit={onTryToEdit}
          poupStateChange={poupStateChange}
        />
      </div>
    </div >
  );
})
